// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"-aKwm","toggleBtn":"iVX6-","titleWrapper":"_7t73J","title":"YGtPG","activeText":"OJC-F","titlePadding":"vn9Lf"};